import styled from '@emotion/styled';
import { useSearchContext } from 'src/contexts/SearchContext';
import { useTranslation } from 'src/hooks';
import { Box, Chip } from 'src/components/atoms';

const StyledChip = styled(Chip)`
  border: 1px solid ${props => props.theme.palette.text.primary};
  padding: 0 0.2rem;
  margin-top: 0.5rem;

  &:not(:last-of-type) {
    margin-right: 0.75rem;
  }
`;

export const Chips = () => {
  const { chips, handleSelectChip, handleRemoveChipsSelection } = useSearchContext();
  const { t } = useTranslation();

  const isAnyChipSelected = chips.some(chip => chip.isSelected);

  const handleClickChip = (chipId: string) => {
    handleSelectChip(chipId);
  };

  const handleClickAllChip = () => {
    handleRemoveChipsSelection();
  };

  return (
    <Box maxWidth='65rem'>
      <StyledChip
        onClick={handleClickAllChip}
        label={t('pages.feed.myme.all')}
        color={!isAnyChipSelected ? 'primary' : 'default'}
      />
      {chips.map(chip => (
        <StyledChip
          onClick={() => handleClickChip(chip.id)}
          label={chip.name}
          key={chip.id}
          color={chip.isSelected ? 'primary' : 'default'}
        />
      ))}
    </Box>
  );
};
